<cerrix-loader
    [showLoader]="showLoader"
    customMessage="Loading Power BI report, this may take up to several minutes..."
></cerrix-loader>
<div class="embedded-powerbi" #container></div>
